import cookieHelper from '../../cookie';
import UAParser from '../utils/UAparser';
import {isInApp} from '../utils/user-agent';

export default {
  getSiteObjectData(key) {
    return window.siteObj[key];
  },
  
  getElementAttribute(element, attribute) {
    return element?.getAttribute(attribute);
  },
  
  getBrowserData(key) {
    return UAParser(navigator.userAgent).browser?.[key];
  },
  
  getUserAgent() {
    return navigator.userAgent;
  },
  
  isMobileLayout() {
    return document.body.scrollWidth <= 767;
  },
  
  getCookie() {
    return cookieHelper.trackingCookie();
  },
  
  getSessCookie() {
    return cookieHelper.trackingSessCookie();
  },
  
  getDeviceInfo(userAgentString) {
    const {device, os} = UAParser(userAgentString);
    
    if (isInApp()) {
      return {
        is_pc: false,
        is_mobile: false,
        is_tablet: false,
        is_app: true,
        family: os.name || '',
        brand: device.vendor || '',
        model: device.model || '',
      };
    }
    
    if (device.type === 'mobile') {
      return {
        is_pc: false,
        is_mobile: true,
        is_tablet: false,
        is_app: false,
        family: os.name || '',
        brand: device.vendor || '',
        model: device.model || '',
      };
    }
    
    if (device.type === 'tablet') {
      return {
        is_pc: false,
        is_mobile: false,
        is_tablet: true,
        is_app: false,
        family: os.name || '',
        brand: device.vendor || '',
        model: device.model || '',
      };
    }
    
    return {
      is_pc: true,
      is_mobile: false,
      is_tablet: false,
      is_app: false,
      family: os.name || '',
    };
  },
};
